import { Component, OnInit } from '@angular/core';
import { AppService, IMessage } from '../../app.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [AppService]
})
export class FooterComponent implements OnInit {

  message: IMessage = {};

  constructor(private appService: AppService) { }


  sendEmail(message:IMessage){
    this.appService.sendEmail(message).subscribe(res => {
    }, error => {
      console.log('ContactComponent Error', error);
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/corpo-leve-www/www/src/app/elements/footer/footer.component.ts